import { useParams } from "react-router-dom"
import TagsUpdatePopup from "../rawImage/ProductsTagsUpdatePopup";



const Trend = () => {

  const mediaId = useParams().mediaId

  return <TagsUpdatePopup mediaId={mediaId} isPage={true} />

}

export default Trend;
